<adspt-icon [style.font-size.px]="size()" class="adspt-icon {{ color() }}-text" [name]="icon()" />
